<template>
    <gd-modal name="leaderboards-team-modal" :title="$t('frontend_groovesell_leaderboard_team')" height="80%" width="80%" class="gs-leaderboard-team"
        :no-overflow="true" @closed="leaderboards_team_modal_closed" allowOverflow>
        <div class="flex flex-row gs-leaderboard-team__toolbar">
            <gd-button variant="primary" size="auto" class="m-3 mr-4 ml-auto gs-leaderboard-team__add" @click="openModal('add-leaderboard-team-modal')">
                <plus-icon class="w-5 h-5 fill-current" />
                {{ $t('frontend_add_team') }}
            </gd-button>
        </div>
        <div class="flex flex-col gs-leaderboard-team__body">
            <!-- Leader Board Team Table View -->
            <div v-if="leaderBordTeamData && leaderBordTeamData.length > 0" class="p-6 flex gs-leaderboard-team__table"
                tabindex="0" role="region" :aria-label="$t('frontend_groovesell_page_tracking_table_actions')"
                id="affiliate-transactions-list-view">
                <v-client-table :data="leaderBordTeamData" :columns="leaderBordTeamColumns" :options="leaderBordTeamOptions"
                    ref="leaderBordTeamTable">
                    <div slot="actions" slot-scope="props">
                        <div class="flex flex-row gs-leaderboard-team__actions">
                            <gd-button variant="primary" size="icon" class="mr-2 gs-leaderboard-team__action"
                                :aria-label="$t('frontend_groovesell_tools_affiliate_tooltip_edit')"
                                @click="editLeaderBoardTeam(props.index, props.row)">
                                <pencil-icon class="w-5 h-5 fill-current" />
                            </gd-button>

                            <gd-button variant="primary" size="icon" class="mr-2 gs-leaderboard-team__action gs-leaderboard-team__action--danger"
                                :aria-label="$t('frontend_groovesell_tools_affiliate_tooltip_delete')"
                                @click="deleteLeaderBoardTeam(props.index, props.row)">
                                <trash-icon class="w-5 h-5 fill-current" />
                            </gd-button>
                        </div>
                    </div>
                </v-client-table>
            </div>
            <div v-else class="p-6 flex gs-leaderboard-team__empty">
                {{ $t('frontend_groovesell_no_teams_desc') }}
            </div>

            <div class="flex flex-row w-full mb-6 justify-end gs-leaderboard-team__footer">
                <gd-button size="auto" class="mr-4 gs-leaderboard-team__save" variant="primary" @click="saveLeaderBoardTeam">{{
                    $t('frontend_save_close') }}</gd-button>
            </div>
        </div>
    </gd-modal>
</template>
<script>
import PencilIcon from '@/assets/images/icons/PencilIcon.svg';
import TrashIcon from '@/assets/images/icons/TrashIcon.svg';
import PlusIcon from '@/assets/images/icons/PlusIcon.svg';

export default {
    components: {
        PencilIcon,
        TrashIcon,
        PlusIcon,
    },
    props: {
        openModal: {
            type: Function,
            required: true
        },
        leaderBordTeamData: {
            type: Array,
            required: true
        },
        editLeaderBoardTeam: {
            type: Function,
            required: true
        },
        deleteLeaderBoardTeam: {
            type: Function,
            required: true
        },
        saveLeaderBoardTeam: {
            type: Function,
            required: true
        },

    },
    data() {
        return {
            leaderBordTeamColumns: ['name', 'affiliates', 'actions'],
            leaderBordTeamOptions: {
                headings: {
                    name: this.$t('frontend_name'),
                    actions: this.$t('frontend_groovesell_page_tracking_table_actions'),
                    affiliates: this.$t('frontend_groovesell_leaderboard_table_affiliate')
                },
                perPage: 5,
                texts: {
                    filterPlaceholder: 'Search',
                    filter: '',
                },
            },
        }
    },
    methods: {
        leaderboards_team_modal_closed() {
            this.$emit('update-attributes', {
                key: 'affiliate_empty_err_add_team',
                value: false
            });

        },


    }

}
</script>
<style scoped>
.gs-leaderboard-team ::v-deep(.gd-modal__content) {
    padding: 0.75rem;
}

.gs-leaderboard-team ::v-deep(.gd-modal__content > div) {
    width: min(860px, calc(100vw - 1.5rem)) !important;
    max-width: calc(100vw - 1.5rem) !important;
    height: auto !important;
}

.gs-leaderboard-team ::v-deep(.gd-modal__content > div > div:first-child) {
    min-height: 4rem;
    height: auto;
    padding: 0.875rem 1rem;
}

.gs-leaderboard-team ::v-deep(.gd-modal__content > div > div:first-child > span:first-child) {
    min-width: 0;
    overflow-wrap: anywhere;
}

.gs-leaderboard-team__toolbar {
    min-width: 0;
}

.gs-leaderboard-team__add,
.gs-leaderboard-team__save,
.gs-leaderboard-team__action {
    min-width: 44px !important;
    min-height: 44px !important;
}

.gs-leaderboard-team__add {
    color: var(--gs-primary) !important;
    background: transparent !important;
    border-color: var(--gs-primary) !important;
    box-shadow: none !important;
}

.gs-leaderboard-team__add:hover:not(:disabled) {
    background: var(--gs-primary-soft) !important;
}

.gs-leaderboard-team__save {
    color: var(--gs-primary-foreground) !important;
    background: var(--gs-primary) !important;
    border-color: var(--gs-primary) !important;
}

.gs-leaderboard-team__table {
    min-width: 0;
    max-width: 100%;
    overflow: visible;
}

.gs-leaderboard-team__table ::v-deep(.VueTables) {
    min-width: 0;
    width: 100%;
}

.gs-leaderboard-team__table ::v-deep(.table-responsive) {
    max-width: 100%;
    overflow-x: auto;
    overscroll-behavior-inline: contain;
    -webkit-overflow-scrolling: touch;
}

.gs-leaderboard-team__table ::v-deep(table) {
    width: 100%;
    min-width: 480px;
    table-layout: fixed;
}

.gs-leaderboard-team__table ::v-deep(th),
.gs-leaderboard-team__table ::v-deep(td) {
    vertical-align: middle;
}

.gs-leaderboard-team__table ::v-deep(th) {
    color: var(--gs-muted-foreground);
}

.gs-leaderboard-team__table ::v-deep(th:nth-child(1)),
.gs-leaderboard-team__table ::v-deep(td:nth-child(1)) {
    width: 46%;
    overflow-wrap: anywhere;
}

.gs-leaderboard-team__table ::v-deep(th:nth-child(2)),
.gs-leaderboard-team__table ::v-deep(td:nth-child(2)) {
    width: 30%;
    overflow-wrap: anywhere;
}

.gs-leaderboard-team__table ::v-deep(th:nth-child(3)),
.gs-leaderboard-team__table ::v-deep(td:nth-child(3)) {
    width: 24%;
}

.gs-leaderboard-team__table ::v-deep(.VueTables__search-field input) {
    min-height: 44px;
}

.gs-leaderboard-team__actions {
    min-width: max-content;
}

.gs-leaderboard-team__action {
    color: var(--gs-primary) !important;
    background: transparent !important;
    border-color: transparent !important;
    box-shadow: none !important;
}

.gs-leaderboard-team__action:hover:not(:disabled) {
    background: var(--gs-primary-soft) !important;
    border-color: transparent !important;
}

.gs-leaderboard-team__action--danger,
.gs-leaderboard-team__action--danger:hover:not(:disabled) {
    color: var(--gs-danger) !important;
}

.gs-leaderboard-team__action--danger:hover:not(:disabled) {
    background: var(--gs-surface-subtle) !important;
}

.gs-leaderboard-team__add:focus-visible,
.gs-leaderboard-team__save:focus-visible,
.gs-leaderboard-team__action:focus-visible,
.gs-leaderboard-team__table:focus-visible {
    outline: 2px solid var(--gs-primary);
    outline-offset: 2px;
    box-shadow: var(--gs-active-shadow) !important;
}

@media (max-width: 640px) {
    .gs-leaderboard-team__toolbar {
        padding: 1rem;
        justify-content: stretch;
    }

    .gs-leaderboard-team__add,
    .gs-leaderboard-team__save {
        width: 100%;
        margin: 0 !important;
    }

    .gs-leaderboard-team__table {
        padding: 1rem;
    }

    .gs-leaderboard-team__footer {
        padding-right: 1rem;
        padding-left: 1rem;
    }
}
</style>
